import { handleActions } from "redux-actions";

import { VIEW_FAILURE, VIEW_REQUEST, VIEW_RESET, VIEW_SUCCESS } from "constants/action-types";

interface IState {
    error?: Error;
    isFetching: boolean;
    result: string[];
}

const initialState: IState = {
    error: undefined,
    isFetching: false,
    result: [],
};

interface IViewFailure {
    error: boolean;
    payload: any;
}

interface IViewSuccess {
    payload: any;
}

export const views = handleActions(
    {
        [VIEW_FAILURE]: (state: IState, { payload }: IViewFailure): IState => {
            return {
                ...state,
                error: payload,
                isFetching: false,
                result: initialState.result,
            };
        },
        [VIEW_REQUEST]: (state: IState): IState => {
            return {
                ...state,
                error: undefined,
                isFetching: true,
            };
        },
        [VIEW_SUCCESS]: (state: IState, { payload }: IViewSuccess): IState => {
            return {
                ...state,
                isFetching: false,
                result: state.result.concat(payload),
            };
        },
        [VIEW_RESET]: (state: IState): IState => {
            return {
                ...state,
                error: undefined,
                isFetching: false,
                result: initialState.result,
            };
        },
    } as any,
    initialState
);
